export default class UrlParser {
  /**
   * Parse tokens from urls
   *
   * @param {String[]} urls
   *
   * @return {String[]}
   */
  static tokens (urls) {
    if (typeof urls === 'string') {
      return UrlParser.parse(urls).searchObject.token
    }
    let tokens = []
    for (let url of urls) {
      tokens.push(UrlParser.parse(url).searchObject.token)
    }
    return tokens
  }

  static parse (url) {
    let parser = document.createElement('a')
    let searchObject = {}

    // Let the browser do the work
    parser.href = url
    // Convert query string to object
    let queries = parser.search.replace(/^\?/, '').split('&')
    for (let i = 0; i < queries.length; i++) {
      let split = queries[i].split('=')
      searchObject[split[0]] = split[1]
    }
    return {
      protocol: parser.protocol,
      host: parser.host,
      hostname: parser.hostname,
      port: parser.port,
      pathname: parser.pathname,
      search: parser.search,
      searchObject: searchObject,
      hash: parser.hash
    }
  }
}
